import Link from 'next/link';
import Price from '../share/Price';
import Img from '../share/Img';
import Image from 'next/image';
import ProductListAddToCart from '../share/ProductListAddToCart';

export default function ProductCarousel({ product, pageType }) {
  const cartItem = {
    number: 1,
    price_id: product?.prices[0]?.id,
    variation: {
      product: {
        media: {
          thumb: product.media?.thumb,
        },
        slug: product.slug,
        title: product.title,
      },
      regular: product?.prices[0]?.regular,
      sale: product?.prices[0]?.sale,
    },
  };

  return (
    <>
      {product ? (
        <div
          className="product-item border border-light-gray-150 h-full p-5 pt-8 w-[240px]
          border-light-gray-300 h-full rounded-xl"
        >
          <Link href={`/product/${product.slug}`}>
            <div className="flex w-full flex-col">
              <div className="product-image relative text-center ">
                <Img image={product?.media?.thumb} width={174} height={160} />
                {product.brand?.thumb && (
                  <div className="absolute -top-6 max-w-50px -left-2 w-[50px] h-[50px]">
                    <Image
                      src={product?.brand[0]?.thumb?.full_path}
                      width={100}
                      height={100}
                      alt={product?.brand[0]?.thumb?.alt}
                    />
                  </div>
                )}

                {product.label_top && (
                  <div
                    className={`absolute text-white text-xs py-1 px-2 -top-4 -right-5 rounded-end label id-${product.label_top.id}`}
                    style={{
                      backgroundColor: product.label_top.background_color,
                    }}
                  >
                    <div className="flex items-center ">
                      <span
                        className="pl-2"
                        dangerouslySetInnerHTML={{
                          __html: product.label_top.icon,
                        }}
                      />
                      <span style={{ color: product.label_top.text_color }}>
                        {product.label_top?.title}
                      </span>
                    </div>
                  </div>
                )}
                {product.label_bottom && (
                  <div
                    className="absolute text-white text-xs py-0.5 px-2 rounded-md bottom-2 right-0"
                    style={{
                      backgroundColor: product.label_bottom.background_color,
                    }}
                  >
                    <span style={{ color: product.label_bottom.text_color }}>
                      {product.label_bottom.title}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="product-info flex-1">
              <div>
                <div className="pb-2 min-h-[70px] text-sm">
                  {product.title}
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </Link>
          <div className="os-product-price  flex justify-between items-center">
            <div>
              <Price
                price={product.prices?.length > 0 ? product.prices[0] : null}
              />
            </div>

            {product.prices?.length > 0 &&
              product.type === 'simple' &&
              product.prices[0].stock > 0 &&
              !product.offline && (
                <ProductListAddToCart cartItem={cartItem} pageType={pageType} />
              )}
          </div>
        </div>
      ) : null}
    </>
  );
}
